export const INTEREST = [
    { id: "Harry Potter" },
    { id: "Дети 90-х" },
    { id: "SoundCloud" },
    { id: "СПА" },
    { id: "Уход за собой" },
    { id: "Хеви-метал" },
    { id: "Вечеринки дома" },
    { id: "Джин с тоником" },
    { id: "Гимнастика" },
    { id: "Горячая йога" },
    { id: "Документалки" },
    { id: "Драматические сериалы" },
    { id: "Медитация" },
    { id: "Гурман(ка)" },
    { id: "Spotify" },
    { id: "Суши" },
    { id: "Хоккей" },
    { id: "Баскетбол" },
    { id: "Фэнтези-фильмы" },
    { id: "Поэтический слэм" },
    { id: "Домашние тренировки" },
    { id: "Театр" },
    { id: "Походы в кафе" },
    { id: "Аквариум" },
    { id: "Кроссовки" },
    { id: "Instagram" },
    { id: "Горячие источники" },
    { id: "Ходьба" },
    { id: "Бег" },
    { id: "Путешествия" },
    { id: "Языковой обмен" },
    { id: "Фильмы" },
    { id: "Боевики" },
    { id: "Анимационные фильмы" },
    { id: "Криминальные сериалы" },
    { id: "Гитаристы" },
    { id: "Социальное развитие" },
    { id: "Спортзал" },
    { id: "Соцсети" },
    { id: "Соул" },
    { id: "Хип-хоп" },
    { id: "Грайм" },
    { id: "Бритпоп 90-х" },
    { id: "Тренировка Bodypump" },
    { id: "Пляжные бары" },
    { id: "Тренировка Bodystep" },
    { id: "Параглайдинг" },
    { id: "Апсайклинг" },
    { id: "Равенство" },
    { id: "Астрология" },
    { id: "Мотоциклы" },
    { id: "Конный спорт" },
    { id: "Предпринимательство" },
    { id: "Саке" },
    { id: "BTS" },
    { id: "Кулинария" },
    { id: "Защита природы" },
    { id: "Катание на коньках" },
    { id: "Инди" },
    { id: "Футбол" },
    { id: "Саксофонист" },
    { id: "Научная фантастика" },
    { id: "Танцы" },
    { id: "Фестиваль кино" },
    { id: "Альтернатива" },
    { id: "Садоводство" },
    { id: "Повар-любитель" },
    { id: "Программа обмена" },
    { id: "Сауна" },
    { id: "Искусство" },
    { id: "Политика" },
    { id: "Фламенко" },
    { id: "Музеи" },
    { id: "Активизм" },
    { id: "Безалкогольные коктейли" },
    { id: "Пляжный спорт" },
    { id: "Техно" },
    { id: "Занятия фитнесом" },
    { id: "Джаз" },
    { id: "Сладости" },
    { id: "DAO (ДАО)" },
    { id: "Недвижимость" },
    { id: "Подкасты" },
    { id: "Права людей с ограниченными возможностями" },
    { id: "Рейвы" },
    { id: "Pimm’s" },
    { id: "Автокинотеатр" },
    { id: "Скалолазание" },
    { id: "Барбекю" },
    { id: "Крафтовое пиво" },
    { id: "Хаус" },
    { id: "Холодный чай" },
    { id: "Барабанщик" },
    { id: "Чай" },
    { id: "EDM" },
    { id: "Настольные игры" },
    { id: "Roblox" },
    { id: "Пабы" },
    { id: "R&B" },
    { id: "Рок" },
    { id: "Танго" },
    { id: "Рисование" },
    { id: "Викторины" },
    { id: "Фо" },
    { id: "Волонтерство" },
    { id: "Инвайронментализм" },
    { id: "Катание на роликах" },
    { id: "Вино" },
    { id: "Подземелья и драконы" },
    { id: "Видеоблогинг" },
    { id: "Электронная музыка" },
    { id: "Красиво писать" },
    { id: "Xbox" },
    { id: "Мир во всём мире" },
    { id: "Борьба" },
    { id: "Литература" },
    { id: "Манга" },
    { id: "Прайд" },
    { id: "Марафон" },
    { id: "Макияж" },
    { id: "Расширение возможностей молодежи" },
    { id: "YouTube" },
    { id: "Боевые искусства" },
    { id: "Marvel" },
    { id: "Хоккей на льду" },
    { id: "Тхэквондо" },
    { id: "Художественная гимнастика" },
    { id: "Веганская кухня" },
    { id: "Гребля" },
    { id: "Вермут" },
    { id: "Корейская еда" },
    { id: "Спортивная стрельба" },
    { id: "Twitter" },
    { id: "Волейбол" },
    { id: "Пешеходные экскурсии" },
    { id: "Виньяса" },
    { id: "Виртуальная реальность" },
    { id: "League of Legends" },
    { id: "Каратэ" },
    { id: "NFT" },
    { id: "Тур по барам" },
    { id: "Nintendo" },
    { id: "Бейсбол" },
    { id: "Вечеринки" },
    { id: "Балет" },
    { id: "Музыкальные группы" },
    { id: "Онлайн-игры" },
    { id: "Пляжный теннис" },
    { id: "Ночная жизнь" },
    { id: "Онлайн-покупки" },
    { id: "Парусный спорт" },
    { id: "Басист" },
    { id: "Природа" },
    { id: "Мемы" },
    { id: "Among Us" },
    { id: "Гонки на мотоциклах" },
    { id: "Тайский бокс" },
    { id: "Мотоспорт" },
    { id: "Метавселенная" },
    { id: "Внимательность" },
    { id: "Акапелла" },
    { id: "Музыкальный инструмент" },
    { id: "Галереи искусств" },
    { id: "Анимационные фильмы" },
    { id: "Криминальные сериалы" },
    { id: "Гитаристы" },
    { id: "Социальное развитие" },
    { id: "Спортзал" },
    { id: "Соцсети" },
    { id: "Соул" },
    { id: "Хип-хоп" },
    { id: "Уход за кожей" },
    { id: "Мюзиклы" },
    { id: "J-pop" },
    { id: "Кальян" },
    { id: "Крикет" },
    { id: "Фриланс" },
    { id: "Скейтбординг" },
    { id: "Госпел" },
    { id: "Поп-музыка" },
    { id: "K-pop" },
    { id: "Любитель(ница) книг о Гарри Поттере" },
    { id: "Панк-рок" },
    { id: "Пробовать что-то новое" },
    { id: "Фотография" },
    { id: "Болливуд" },
    { id: "Чтение" },
    { id: "Пение" },
    { id: "Рэп" },
    { id: "Спорт" },
    { id: "Поэзия" },
    { id: "Стендап-комедия" },
    { id: "Кофе" },
    { id: "Караоке" },
    { id: "Fortnite" },
    { id: "Фридайвинг" },
    { id: "Саморазвитие" },
    { id: "Духовное развитие" },
    { id: "Гастрономические туры" },
    { id: "Горы" },
    { id: "Стрельба из лука" },
    { id: "Atari" },
    { id: "Походы" },
    { id: "Рыбалка" },
    { id: "Клубы" },
    { id: "Уличная еда" },
    { id: "Кроссфит" },
    { id: "Концерты" },
    { id: "Скалолазание" },
    { id: "Выпечка" },
    { id: "Кемпинг" },
    { id: "Блогинг" },
    { id: "Растительное питание" },
    { id: "Автомобили" },
    { id: "Стартапы" },
    { id: "Чай с шариками" },
    { id: "Коктейли" },
    { id: "Бадминтон" },
    { id: "Активный образ жизни" },
    { id: "Мода" },
    { id: "Аниме" },
    { id: "НБА" },
    { id: "Главная лига бейсбола" },
    { id: "Фанк-музыка" },
    { id: "Дайвинг" },
    { id: "Кайпиринья" },
    { id: "Флаг-футбол" },
    { id: "Бары" },
    { id: "Синхронное плавание" },
    { id: "Атлетика" },
    { id: "Пляжный волейбол" },
    { id: "Самодельничество" },
    { id: "Городские праздники" },
    { id: "Велоспорт" },
    { id: "Занятия на свежем воздухе" },
    { id: "TikTok" },
    { id: "Пикник" },
    { id: "Twitch" },
    { id: "Дзюдо" },
    { id: "Комедия" },
    { id: "Трэп" },
    { id: "Музыка" },
    { id: "Триатлон" },
    { id: "Netflix" },
    { id: "Дисней" },
    { id: "Регби" },
    { id: "Асаи" },
    { id: "Самба" },
    { id: "Таро" },
    { id: "Фондовая биржа" },
    { id: "Акции" },
    { id: "Плавание" },
    { id: "Любовь к себе" },
    { id: "Настольный теннис" },
    { id: "Тренировки" },
    { id: "Йога" },
    { id: "Фильмы о привидениях" },
    { id: "Бокс" },
    { id: "Отдых в барах" },
    { id: "Выставки" },
    { id: "Жаркое из свинины" },
    { id: "Катание на лыжах" },
    { id: "Каноэ" },
    { id: "Вест-эндские мюзиклы" },
    { id: "Сноубординг" },
    { id: "Пилатес" },
    { id: "Пятиборье" },
    { id: "Бродвей" },
    { id: "PlayStation" },
    { id: "Чирлидинг" },
    { id: "Хор" },
    { id: "Пол дэнс" },
    { id: "Мини-футбол" },
    { id: "Автогонки" },
    { id: "Pinterest" },
    { id: "Опера" },
    { id: "Викторины в пабе" },
    { id: "Фестивали" },
    { id: "Катан" },
    { id: "Косплей" },
    { id: "Автоспорт" },
    { id: "Кофейня" },
    { id: "Создание контента" },
    { id: "Киберспорт" },
    { id: "Гонки на велосипедах" },
    { id: "Просмотр сериалов" },
    { id: "Написание песен" },
    { id: "Тренировка Bodycombat" },
    { id: "Татуировки" },
    { id: "Рисовать" },
    { id: "Бодиджем" },
    { id: "Сап-серфинг" },
    { id: "Падель" },
    { id: "Blackpink" },
    { id: "Сёрфинг" },
    { id: "Боулинг" }
];
